module.exports = __webpack_public_path__ + "static/media/activate-waiting.a2439fb3.png";